(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-loc-bliss-bars"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const builder = document.querySelector('[data-bar-builder]');
    if (!builder) return;

    const selections = new Map();
    const count = builder.querySelector('[data-bar-count]');
    const subtotal = builder.querySelector('[data-bar-subtotal]');
    const addButton = builder.querySelector('[data-add-selected]');
    const error = builder.querySelector('[data-bar-error]');
    const cart = document.querySelector('cart-drawer');
    const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
      style: 'currency',
      currency: builder.dataset.currency || 'USD'
    });

    const updateSummary = () => {
      const selected = Array.from(selections.values());
      const total = selected.reduce((sum, item) => sum + item.price, 0);
      const countTemplate = selected.length === 1
        ? (count.dataset.countOne || '[count] bar selected')
        : (count.dataset.countOther || '[count] bars selected');
      count.textContent = countTemplate.replace('[count]', String(selected.length));
      subtotal.textContent = formatter.format(total / 100);
      addButton.disabled = selected.length === 0;
    };

    builder.querySelectorAll('[data-bar-select]').forEach((button) => {
      button.addEventListener('click', () => {
        const id = button.dataset.variantId;
        const selected = button.getAttribute('aria-pressed') === 'true';

        if (selected) {
          selections.delete(id);
        } else {
          selections.set(id, {
            id: Number(id),
            quantity: 1,
            price: Number(button.dataset.variantPrice)
          });
        }

        button.setAttribute('aria-pressed', String(!selected));
        button.textContent = selected ? button.dataset.addLabel : button.dataset.selectedLabel;
        button.closest('.bb-variant-card')?.classList.toggle('is-selected', !selected);
        error.hidden = true;
        updateSummary();
      });
    });

    addButton.addEventListener('click', async () => {
      if (selections.size === 0) return;

      addButton.disabled = true;
      addButton.textContent = addButton.dataset.addingLabel;
      error.hidden = true;

      const sectionIds = cart?.getSectionsToRender().map((section) => section.id) || ['cart-icon-bubble'];

      try {
        const response = await fetch(builder.dataset.cartUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: Array.from(selections.values()).map(({ id, quantity }) => ({ id, quantity })),
            sections: sectionIds,
            sections_url: window.location.pathname
          })
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || builder.dataset.errorMessage);

        if (cart) {
          cart.renderContents(result);
        } else {
          window.location.assign((window.routes && window.routes.cart_url) || '/cart');
          return;
        }

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bar-builder', cartData: result });
        }

        builder.querySelectorAll('[data-bar-select][aria-pressed="true"]').forEach((button) => {
          button.setAttribute('aria-pressed', 'false');
          button.textContent = button.dataset.addLabel;
          button.closest('.bb-variant-card')?.classList.remove('is-selected');
        });
        selections.clear();
        updateSummary();
        addButton.textContent = addButton.dataset.addedLabel;
        window.setTimeout(() => {
          addButton.textContent = addButton.dataset.defaultLabel;
        }, 1600);
      } catch (requestError) {
        error.textContent = requestError.message || builder.dataset.errorMessage;
        error.hidden = false;
        addButton.disabled = false;
        addButton.textContent = addButton.dataset.defaultLabel;
      }
    });

    updateSummary();
  })();

  } catch(e) { console.error(e); }
})();
})();
